<template>
  <div v-if="getValue()">
    <template v-if="showPassword">
      <pre
        class="text-orange-600 cursor-pointer inline-block hover:bg-blue-100"
        title="In die Zwischenablage kopieren"
        @click="copyToClipboard()"
      >{{ getValue() }}</pre>
      <button
        type="button"
        class="text-gray-900 hover:underline focus:outline-none"
        @click="showPassword = false"
      >
        Passwort ausblenden
      </button>
    </template>
    <template v-else>
      <div>******</div>
      <button
        type="button"
        class="text-gray-900 hover:underline focus:outline-none"
        @click="showPassword = true"
      >
        Passwort anzeigen
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data: () => ({
    showPassword: false
  }),

  methods: {
    getValue() {
      return this.row[this.column.field]
    },

    copyToClipboard() {
      window.navigator.clipboard.writeText(this.getValue()).then(() => {
        window.eventBus.$emit('mia-info', {
          info: ['Passwort in die Zwischenablage kopiert!']
        })
      }).catch(() => {
        window.eventBus.$emit('mia-error', {
          error: ['Passwort Kopieren fehlgeschlagen']
        })
      }).finally(() => {
        this.showPassword = false
      })
    }
  }
}
</script>
